import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  TablePagination,
  Button,
  Popover,
  TextField,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import axios from "axios";
import { getSearchEngine } from "../network_requests";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

export default function SearchEngine(props) {
  const [rows, setRows] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [load, setLoad] = useState(false);
  const [name, setName] = useState("");
  const [search, setSearch] = useState(null);

  useEffect(async () => {
    const cancelToken = axios.CancelToken;
    const source = cancelToken.source();

    (async () => {
      if (search) {
        setLoad(true);
        const searchData = await getSearchEngine(search);
        setRows(searchData ? searchData : []);
        setLoad(false);
      }
    })();

    return () => {
      source.cancel();
    };
  }, [search]);
  return (
    <>
      <TableContainer component={Paper}>
        <Table size="small" style={{ tableLayout: "fixed" }} stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell align="right">
                <TextField
                  variant="outlined"
                  size="small"
                  placeholder="Search..."
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      setSearch(name);
                    }
                  }}
                ></TextField>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {load ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  paddingTop: "20px",
                  paddingBottom: "20px",
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              rows?.map((table) => {
                return (
                  <>
                    <Typography variant="h6" style={{ padding: "10px" }}>
                      Title: {table?.titles}
                    </Typography>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "10px",
                      }}
                    >
                      <div
                        style={{
                          height: rows.length > 1 ? "50vh" : "90vh",
                          overflow: "scroll",
                          width: "100%",
                        }}
                        className="ag-theme-alpine invisible-scrollbar"
                      >
                        <AgGridReact
                          defaultColDef={{
                            sortable: true,
                            filter: true,
                          }}
                          rowData={table.values}
                          rowSelection={"single"}
                        >
                          {table.columns.map((value) => {
                            return (
                              <AgGridColumn
                                field={value}
                                filter="agTextColumnFilter"
                                width={140}
                              />
                            );
                          })}
                        </AgGridReact>
                      </div>
                    </div>
                  </>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
